import { Divider } from 'antd'
import React, { useState, useEffect } from 'react'
import { fetchActiveEvent, fetchCampaignPromo } from '../../apis/affiliateWeb'

function ActiveEvent(props) {
    const { userInfo, ln_t, history, location } = props
    const { roleId, nowEnterprise } = userInfo || {}
    const { name } = nowEnterprise || {}
    const { enterprise } = nowEnterprise || {}

    const { state } = location || {}
    const { eventClosed } = state || {}

    const [datas, setDatas] = useState([])
    const [close, setClose] = useState(eventClosed)
    const [events, setEvents] = useState([])

    const getDatas = async () => {
        const results = await fetchActiveEvent(roleId, enterprise)
        const { keys, response } = results || {}
        if (Array.isArray(response)) {
            let tmp = []
            response.forEach((res, index) => {
                if (res?.status !== 200) return
                const key = keys[index]
                const { results } = res.data || {}
                if (!index) {
                    tmp = results?.[0]?.products?.map(item => ({ product: item.product_id, [key]: item.referralRate })) || []
                    setEvents(results.filter(res => res.name !== 'default'))
                } else tmp = tmp.map(item => ({ ...item, ...res.data?.find(pro => pro.product === item.product) }))
            })
            // tmp.pop() // remove later -> request from ezTravel to hide the domestic travel temporarily
            setDatas(tmp)
        }
    }

    useEffect(() => {
        getDatas()
    }, []) 

    return (
        <section className="active-event">
            <Divider>{ln_t('enterprise.currentRate')}</Divider>
            <div className="inner">
                {datas.map((data, idx) => {
                    const { product, defaultRate, referralRate, description } = data
                    const higher = referralRate > defaultRate
                    const name = description || product
                    return (
                        <div 
                            key={`${idx}-event`} 
                            className="d-flex justify-content-between w-100 mb-2 align-items-center product-item"
                        >
                            <span>{name}</span>
                            <div>
                                <span className={higher ? 'lower' : 'higher'}>{defaultRate}%</span>
                                {higher ? <span className="ml-2 higher">{referralRate}%</span> : ''}
                            </div>
                        </div>
                    )
                })}
            </div>
        </section>
    )
}

export default ActiveEvent
